(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header = document.currentScript.closest('header') || document.querySelector('.site-header');
  if (!header) return;
  var isHome = header.getAttribute('data-home') === 'true';
  if (isHome) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  var phrases = header.querySelectorAll('.site-announcement__phrase');
  if (phrases.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var pi = 0;
    setInterval(function () {
      phrases[pi].classList.remove('is-active');
      pi = (pi + 1) % phrases.length;
      phrases[pi].classList.add('is-active');
    }, 3200);
  }
  var btn = header.querySelector('[data-menu-toggle]');
  var menu = header.querySelector('[data-mobile-menu]');
  if (btn && menu) {
    btn.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden');
      if (open) { menu.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
      else { menu.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.currentScript.closest('.hero') || document.querySelector('.hero');
  if (!section) return;
  var slides = section.querySelectorAll('.hero__slide');
  if (slides.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var i = 0;
  setInterval(function () {
    slides[i].classList.remove('is-active');
    i = (i + 1) % slides.length;
    slides[i].classList.add('is-active');
  }, 6000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inner-circle-popup"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-ic-popup]');
  if (!root) return;

  var KEY = 'innerslf_inner_circle';
  var SNOOZE_DAYS = 14;
  var path = window.location.pathname;
  if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;

  function readState() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeState(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }

  var formBody = root.querySelector('[data-ic-state="form"]');
  var successBody = root.querySelector('[data-ic-state="success"]');
  var lastFocus = null;

  function open(mode) {
    if (mode === 'success') { formBody.hidden = true; successBody.hidden = false; }
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      var first = root.querySelector('input[type="email"]');
      if (mode !== 'success' && first) first.focus();
    });
    document.addEventListener('keydown', onKey);
  }

  function close(reason) {
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    window.setTimeout(function () { root.hidden = true; }, 500);
    if (reason === 'dismiss') {
      var s = readState();
      if (!s.s) writeState({ d: Date.now() });
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close('dismiss'); return; }
    if (e.key !== 'Tab') return;
    var items = root.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    var list = Array.prototype.filter.call(items, function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  root.querySelectorAll('[data-ic-close]').forEach(function (el) {
    el.addEventListener('click', function () { close('dismiss'); });
  });

  // Returned from a successful popup signup
  if (/[?&](ic_joined=1|customer_posted=true)/.test(window.location.search)) {
    writeState({ s: 1 });
    if (window.location.search.indexOf('ic_joined=1') > -1) {
      open('success');
      window.setTimeout(function () { close('subscribed'); }, 9000);
    }
    return;
  }

  var state = readState();
  if (state.s) return;
  if (state.d && Date.now() - state.d < SNOOZE_DAYS * 24 * 60 * 60 * 1000) return;

  var delay = parseInt(root.getAttribute('data-delay'), 10) || 30000;
  window.setTimeout(function () { open('form'); }, delay);

  // Debug hook (harmless in production)
  window.__innerCirclePopup = { open: open, close: close };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  // Gallery thumbnail swap
  var gallery = document.querySelector('.product-gallery');
  if (gallery) {
    var main = gallery.querySelector('#ProductMainImage');
    var thumbs = gallery.querySelectorAll('.product-thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (main && t.dataset.full) main.src = t.dataset.full;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  // Buy box: the radios carry selling_plan (empty = one-time), so the form is
  // always correct even without JS. JS only reveals the cadence select and
  // mirrors its choice onto the subscribe radio's value.
  var bb = document.querySelector('[data-buybox]');
  if (bb) {
    var delivery = bb.querySelector('.buybox__delivery');
    var planSelect = bb.querySelector('.buybox__plan');
    var subRadio = bb.querySelector('.buybox__radio--subscribe');
    function sync() {
      var sub = subRadio && subRadio.checked;
      if (delivery) delivery.classList.toggle('hidden', !sub);
    }
    var subPrice = bb.querySelector('.buybox__sub-price');
    if (planSelect && subRadio) {
      planSelect.addEventListener('change', function () {
        subRadio.value = planSelect.value;
        var opt = planSelect.options[planSelect.selectedIndex];
        if (subPrice && opt && opt.dataset.price) subPrice.textContent = opt.dataset.price;
      });
    }
    bb.querySelectorAll('.buybox__radio').forEach(function (r) {
      r.addEventListener('change', sync);
    });
    sync();
  }

  // Mobile sticky buy bar — appears once the inline Add to Ritual scrolls away.
  var stickyBar = document.querySelector('[data-buy-sticky]');
  var inlineBtn = document.querySelector('#ProductForm button[type="submit"]');
  if (stickyBar && inlineBtn) {
    var ticking = false;
    function update() {
      var r = inlineBtn.getBoundingClientRect();
      var off = r.bottom < 0;
      stickyBar.classList.toggle('is-visible', off);
      stickyBar.setAttribute('aria-hidden', off ? 'false' : 'true');
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();

// Product gallery (AZUL / CARBON): the deodorant-opening video auto-plays once
// when it scrolls into view (no scrubbing — can't freeze). The other photos live
// in a sideways scroll/swipe carousel (arrows + dots), thumbnails removed.
(function () {
  var root = document.querySelector('[data-scroll-open]');
  if (!root) return;
  var video = root.querySelector('[data-scrub-video]');
  var track = root.querySelector('[data-psg-track]');
  var prev = root.querySelector('[data-psg-prev]');
  var next = root.querySelector('[data-psg-next]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-psg-dot]'));

  // --- Auto-opening video (opens by itself when it scrolls into view) ---
  if (video) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var startT = parseFloat(root.getAttribute('data-start')) || 0;
    var endT = 6, begun = false, didSetup = false;
    function nowMs() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

    // Reliable forced-open: tween currentTime forward over ~3s with a throttled
    // seek (one in flight). Used when real playback won't advance (autoplay
    // blocked / stalled). Forward-only + throttled => smooth, never sticks.
    function seekTween() {
      var t0 = nowMs(), OPEN_MS = 3000, seeking = false, seekAt = 0, target = startT;
      video.addEventListener('seeked', function () { seeking = false; });
      function apply() {
        if (seeking && nowMs() - seekAt < 350) return;
        if (Math.abs(video.currentTime - target) < 0.02) { seeking = false; return; }
        seeking = true; seekAt = nowMs();
        try { video.currentTime = target; } catch (e) { seeking = false; }
      }
      function frame() {
        var p = Math.min(1, (nowMs() - t0) / OPEN_MS);
        target = startT + p * (endT - startT);
        apply();
        if (p < 1) requestAnimationFrame(frame); else { target = endT; apply(); }
      }
      requestAnimationFrame(frame);
    }

    function begin() {
      if (begun) return; begun = true;
      try { video.currentTime = startT; } catch (e) {}
      if (reduce) { try { video.currentTime = endT; } catch (e) {} return; }
      video.addEventListener('ended', function () { try { video.pause(); video.currentTime = endT; } catch (e) {} });
      var base = video.currentTime;
      var pr = video.play();
      if (pr && pr.catch) pr.catch(function () {});
      // If real playback hasn't advanced shortly, force the open via the tween.
      window.setTimeout(function () {
        if (video.paused || video.currentTime <= base + 0.05) { try { video.pause(); } catch (e) {} seekTween(); }
      }, 500);
    }

    function setup() {
      if (didSetup) return; didSetup = true;
      endT = (video.duration || 6) - 0.05;
      if (startT >= endT || startT < 0) startT = 0;
      try { video.currentTime = startT; } catch (e) {}
      if (reduce) { try { video.currentTime = endT; } catch (e) {} return; }
      // Open the moment it's on screen — check immediately (don't depend on the
      // IntersectionObserver firing), keep observing for later, and also trigger
      // on first scroll/tap as a safety net.
      function inView() { var r = video.getBoundingClientRect(); return r.bottom > 0 && r.top < (window.innerHeight || 9999); }
      if (inView()) begin();
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { begin(); io.disconnect(); } }); }, { threshold: 0.2 });
        io.observe(video);
      }
      var kick = function () { begin(); window.removeEventListener('scroll', kick); window.removeEventListener('touchstart', kick); };
      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('touchstart', kick, { passive: true });
    }
    if (video.readyState >= 1) setup();
    else { video.addEventListener('loadedmetadata', setup); video.addEventListener('canplay', setup); }
  }

  // --- Sideways carousel ---
  if (track) {
    function slideW() { return track.clientWidth || 1; }
    function count() { return track.children.length; }
    function index() { return Math.round(track.scrollLeft / slideW()); }
    function tnow() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
    function goTo(i) {
      i = Math.max(0, Math.min(count() - 1, i));
      var from = track.scrollLeft, to = i * slideW(), t0 = tnow(), D = 380;
      track.style.scrollSnapType = 'none';
      (function step() {
        var p = Math.min(1, (tnow() - t0) / D), e = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = from + (to - from) * e;
        if (p < 1) requestAnimationFrame(step);
        else { track.scrollLeft = to; track.style.scrollSnapType = ''; update(); }
      })();
    }
    function update() {
      var i = index();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= count() - 1;
    }
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-psg-dot'), 10) || 0); }); });
    var ticking = false;
    track.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nature-to-lab"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secs = document.querySelectorAll('.ntl[data-ntl]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  secs.forEach(function (sec) {
    if (reduce || !('IntersectionObserver' in window)) { sec.classList.add('is-done'); return; }
    var started = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !started) {
          started = true;
          io.unobserve(sec);
          sec.classList.add('is-drawing');
          setTimeout(function () { sec.classList.add('is-expanding'); }, 2500);
          setTimeout(function () { sec.classList.add('is-done'); }, 6400);
        }
      });
    }, { threshold: 0.45 });
    io.observe(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bars = document.querySelectorAll('.trust-bar');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  bars.forEach(function (bar) {
    var ph = bar.querySelectorAll('.trust-bar__phrase');
    if (ph.length < 2) return;
    var i = 0;
    setInterval(function () {
      ph[i].classList.remove('is-active');
      i = (i + 1) % ph.length;
      ph[i].classList.add('is-active');
    }, 3200);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
